<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('finance.bankTransactionsTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            verify_permission: 'verify_bank_transaction'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :showVerifyAll="true"
          :confirmVerifyAll="confirmVerifyAll"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12 pt-0">
          <v-layout
            wrap
            style="margin: 0px"
          >
            <v-flex
              xs12
              sm4
              md3
            >
              <v-select
                style="width: 100%"
                autocomplete
                :items="banksList"
                v-model="tableData.bank_id"
                :label="$t('finance.filterByBank')"
                single-line
                clearable
                @input="getResults()"
              />
            </v-flex>
            <v-flex
              xs12
              sm4
              md3
              class="pl-2"
            >
              <v-select
                style="width: 100%"
                :items="statusList"
                v-model="tableData.status"
                :label="$t('finance.filterByStatus')"
                single-line
                clearable
                @input="getResults()"
              />
            </v-flex>
            <v-flex
              xs12
              sm4
              md3
              class="pl-2"
            >
              <v-select
                style="width: 100%"
                :items="transactionTypeList"
                v-model="tableData.transaction_type"
                :label="$t('finance.filterByType')"
                single-line
                clearable
                @input="getResults()"
              />
            </v-flex>
          </v-layout>

          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.bank_transaction_id"
                :style="selectedIds.find(function(x) { return x == r.bank_transaction_id }) ? 'background-color: #FFF9C4' : ''"
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="r.bank_transaction_id"
                    v-model="selectedIds"
                  />
                </td>
                <td>{{ r.bank_transaction_id }}</td>
                <td>{{ r.bank_name }}</td>
                <td>
                  <v-chip
                    small
                    label
                    :color="getTypeColor(r.transaction_type)"
                    outline
                  >
                    {{ formatType(r.transaction_type) }}
                  </v-chip>
                </td>
                <td>{{ r.description }}</td>
                <td>{{ r.actual_cost }}</td>
                <td>
                  <v-chip
                    small
                    label
                    :color="getStatusColor(r.status)"
                    outline
                  >
                    {{ r.status }}
                  </v-chip>
                </td>
                <td>
                  <v-chip
                    small
                    label
                    :color="r.verified ? 'green' : 'grey'"
                    outline
                    class="verify-chip"
                    @click="toggleVerify(r)"
                  >
                    {{ r.verified ? $t('common.yes') : $t('common.no') }}
                  </v-chip>
                </td>
                <td>{{ r.full_name }}</td>
                <td>{{ r.transaction_date }}</td>
                <!-- <td>{{ r.created_at }}</td> -->
                <td>{{ r.updated_at | moment('YYYY-MM-DD hh:mm A') }}</td>
                <td style="padding: 0px 5px">
                  <a
                    style="color:#01579B"
                    :tooltip="$t('orders.viewDetails')"
                    @click="showDetail(r)"
                  >
                    <i class="material-icons">visibility</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <table
            v-if="footer"
            class="table"
          >
            <tr>
              <td style="padding: 3px; font-weight: bold; color: #006b8d">
                {{ $t('finance.totalAmount') }}: {{ footer.total_amount }}
              </td>
            </tr>
          </table>

          <view-bank-transaction
            :instance="viewInstance"
            :detailDialog="detailDialog"
            @close="detailDialog = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import ViewBankTransaction from './viewBankTransaction.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-bank-transaction': ViewBankTransaction
  },
  mounted() {
    this.perPageFix()
    this.getBanksList()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    var sortOrders = {}
    var columns = [
      { label: '', name: '', text: this.$t('columns.checkBox'), value: '1' },
      {
        label: this.$t('columns.id'),
        text: this.$t('columns.id'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'bank_transaction_id'
      },
      {
        label: this.$t('columns.bankName'),
        text: this.$t('columns.bankName'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'bank_name'
      },
      {
        label: this.$t('columns.type'),
        text: this.$t('columns.type'),
        value: '4',
        sortable: true,
        searchable: true,
        name: 'transaction_type'
      },
      {
        label: this.$t('columns.description'),
        text: this.$t('columns.description'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'description'
      },
      {
        label: this.$t('columns.amount'),
        text: this.$t('columns.amount'),
        value: '6',
        sortable: true,
        searchable: true,
        name: 'actual_cost'
      },
      {
        label: this.$t('columns.status'),
        text: this.$t('columns.status'),
        value: '7',
        sortable: true,
        searchable: true,
        name: 'status'
      },
      {
        label: this.$t('columns.verified'),
        text: this.$t('columns.verified'),
        value: '8',
        sortable: true,
        searchable: true,
        name: 'verified'
      },
      {
        label: this.$t('columns.staff'),
        text: this.$t('columns.staff'),
        value: '9',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: this.$t('columns.transactionDate'),
        text: this.$t('columns.transactionDate'),
        value: '10',
        sortable: true,
        searchable: true,
        name: 'transaction_date'
      },
      // {
      //   label: 'Created At',
      //   text: 'Created At',
      //   value: '11',
      //   sortable: true,
      //   searchable: true,
      //   name: 'created_at'
      // },
      {
        label: this.$t('columns.updatedAt'),
        text: this.$t('columns.updatedAt'),
        value: '11',
        sortable: true,
        searchable: true,
        name: 'updated_at'
      },
      {
        label: this.$t('columns.actions'),
        text: this.$t('columns.actions'),
        value: '12',
        name: 'actions'
      }
    ]
    columns.forEach(function (column) {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/bank_transactions',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      selectedIds: [],
      apiResults: [],
      banksList: [],
      footer: null,
      detailDialog: false,
      viewInstance: {},
      statusList: [
        { text: this.$t('finance.statusPaid'), value: 'paid' },
        { text: this.$t('finance.statusUnpaid'), value: 'unpaid' },
        { text: this.$t('finance.statusPending'), value: 'pending' },
        { text: this.$t('finance.statusCancel'), value: 'cancel' },
        { text: this.$t('finance.statusRefunded'), value: 'refunded' },
        { text: this.$t('finance.statusPartialRefunded'), value: 'partial_refunded' }
      ],
      transactionTypeList: [
        { text: this.$t('finance.typeOrder'), value: 'order' },
        { text: this.$t('finance.typeMoneyTransfer'), value: 'money_transfer' },
        { text: this.$t('finance.typeExpense'), value: 'expense' },
        { text: this.$t('finance.typeCreditInvoice'), value: 'credit_invoice' },
        { text: this.$t('finance.typeCashBack'), value: 'cash_back' },
        { text: this.$t('finance.typeDigitalPayment'), value: 'digital_payment' }
      ],
      columns: columns,
      sortKey: 'bank_transaction_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'bank_transaction_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        bank_id: '',
        status: '',
        transaction_type: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getStatusColor(status) {
      var colors = {
        paid: 'green',
        unpaid: 'grey',
        pending: 'orange',
        cancel: 'red',
        refunded: 'blue',
        partial_refunded: 'purple'
      }
      return colors[status] || 'grey'
    },

    getTypeColor(type) {
      var colors = {
        order: 'blue',
        money_transfer: 'teal',
        expense: 'orange',
        credit_invoice: 'green',
        cash_back: 'purple',
        digital_payment: 'indigo'
      }
      return colors[type] || 'grey'
    },

    formatType(type) {
      if (!type) return ''
      return type.replace(/_/g, ' ')
    },

    showDetail(row) {
      this.viewInstance = row
      this.detailDialog = true
    },

    toggleVerify(row) {
      if (!this.$_has_perm('verify_bank_transaction')) return
      var token = localStorage.getItem('access_token')
      axios
        .put('api/bank_transactions/' + row.bank_transaction_id + '/toggle-verify', {}, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(function () {
          row.verified = !row.verified
        })
        .catch(function () {
          swal(this.$t('common.error'), this.$t('finance.couldNotUpdateVerificationStatus'), 'error')
        }.bind(this))
    },

    getBanksList() {
      var token = localStorage.getItem('access_token')
      axios.get('api/get_banks', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        this.banksList = []
        res.data.data.forEach(function (e) {
          this.banksList.push({ text: e.bank_name, value: e.bank_id })
        }.bind(this))
      }.bind(this))
    },

    checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    confirmVerifyAll() {
      if (this.selectedIds.length === 0) {
        swal(this.$t('common.error'), this.$t('finance.pleaseSelectTransactionsToVerify'), 'error')
        return
      }

      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('finance.verifySelectedTransactionsConfirm', { count: this.selectedIds.length }),
        icon: 'warning',
        buttons: true
      }).then(function (willVerify) {
        if (willVerify) {
          this.verifySelectedTransactions()
        }
      }.bind(this))
    },

    verifySelectedTransactions() {
      var token = localStorage.getItem('access_token')
      axios
        .post('api/bank_transactions/verify-multiple', { ids: this.selectedIds }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(function () {
          this.getResults()
          swal({
            title: this.$t('common.done'),
            text: this.$t('finance.transactionsVerifiedSuccessfully'),
            icon: 'success',
            timer: 1500,
            buttons: false
          })
          this.unCheckAll()
          this.selectedIds = []
        }.bind(this))
        .catch(function () {
          swal(this.$t('common.error'), this.$t('finance.pleaseTryAgain'), 'error')
        }.bind(this))
    },

    showHideColumn(prevColVal, currentColVal) {
      var a = []
      var diff = []

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (var j = 0; j < currentColVal.length; j++) {
          if (a[currentColVal[j]]) {
            delete a[currentColVal[j]]
          } else {
            a[currentColVal[j]] = true
          }
        }

        for (var k in a) {
          diff.push(k)
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (var m = 0; m < currentColVal.length; m++) {
          var visible = $(
            'td:nth-child(' + currentColVal[m] + '),th:nth-child(' + currentColVal[m] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[m] + '),th:nth-child(' + currentColVal[m] + ')'
            ).toggle()
          }
        }
      }
    },

    getResults(url) {
      url = url || this.url
      var token = localStorage.getItem('access_token')
      var theDatatable = document.querySelector('.the-datatable')
      var thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action (Verify), affecting rows the user never
      // intended to touch in the current (filtered) view.
      this.selectedIds = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(function (response) {
          var data = response.data
          var isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
            if (data.data.footer) {
              this.footer = data.data.footer
            }
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        }.bind(this))
        .then(function () {
          this.totalResult = 0
          for (var i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        }.bind(this))
        .catch(function () {})
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'bank_transaction_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'bank_transaction_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.bank_id = ''
      this.tableData.status = ''
      this.tableData.transaction_type = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'bank_transaction_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'bank_transaction_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.bank_id = ''
      this.tableData.status = ''
      this.tableData.transaction_type = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

.verify-chip,
.verify-chip * {
  cursor: pointer !important;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bankTransactions/bankTransactions.vue